import { css } from '@emotion/react';
import styled from '@emotion/styled';
import CrestIcon from '@/assets/icons/crest.svg?react';
import StarIcon from '@/assets/icons/star.svg?react';

export const Wrapper = styled.div<{ isReady?: boolean }>`
  position: fixed;
  right: 50px;
  bottom: 40px;
  display: flex;
  height: 60px;
  padding: 4px;
  overflow: hidden;
  cursor: pointer;
  border: 1px solid #ccc;
  border-radius: 40px;
  background: #fff;
  box-shadow: 0 0 4px 0 #0003;
  box-sizing: border-box;

  ${({ theme }) => css`
    ${theme.widget.wrapper.styles}

    @media (${theme.mediaMobile}) {
      ${theme.widget.wrapper.mobile}
    }

    @media not (${theme.mediaMobile}) {
      ${theme.widget.wrapper.desktop}
    }
  `}
`;

export const Content = styled.div<{ width?: number; isReady?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${({ isReady, width }) => (isReady ? (width ? `${width}px` : '70px') : '30px')};
  color: #000;
  overflow: hidden;
  white-space: nowrap;
  border: ${({ theme }) => `1px solid ${theme.colors.dark}`};
  border-radius: 60px;
  box-shadow: 0 1px 4px 0 #f8e2dd;
  z-index: 1;
  transition: width 300ms ease-in-out;

  ${({ theme }) => css`
    ${theme.widget.content.styles}

    @media (${theme.mediaMobile}) {
      ${theme.widget.content.mobile}
    }

    @media not (${theme.mediaMobile}) {
      ${theme.widget.content.desktop}
    }
  `}
`;

export const TextBlock = styled.div<{ isVisible?: boolean }>`
  position: absolute;
  display: flex;
  align-items: center;
  font-size: 13px;
  font-weight: 500;
  opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
  letter-spacing: 0.15px;
  box-sizing: border-box;
  transition: opacity 150ms ease-in-out;
  transition-delay: ${({ isVisible }) => (isVisible ? '125ms' : 0)};

  p {
    margin: 0;
  }

  strong {
    font-weight: 900;
  }
`;

export const Title = styled(TextBlock)<{ isTitleSet: boolean }>`
  padding: 0 12px;
  column-gap: ${({ isTitleSet }) => (isTitleSet ? '4px' : '0')};

  ${({ theme }) => theme.widget.title};
`;

export const Tooltip = styled(TextBlock)<{ isCloseBtnVisible?: boolean }>`
  padding: 0 30px 0 16px;
  padding-left: ${({ isCloseBtnVisible }) => (isCloseBtnVisible ? 16 : 30)}px;

  ${({ theme }) => theme.widget.popup};
`;

export const Star = styled(StarIcon)`
  position: absolute;
  fill: ${({ theme }) => theme.colors.dark};

  ${({ theme }) => theme.widget.star};
`;

export const Stars = styled.div`
  position: relative;
  display: inline-block;
  width: 22px;
  height: 26px;
  vertical-align: middle;
  ${({ theme }) => theme.widget.starsContainer}

  ${Star} {
    &:first-of-type {
      bottom: 0;
      left: 0;
      width: 12px;
      height: 12px;
    }

    &:last-child {
      top: 0;
      right: 0;
      width: 16px;
      height: 16px;
    }
  }
`;

export const CloseButton = styled.button`
  margin-right: 10px;
  padding: 4px;
  cursor: pointer;
  border: none;
  background: none;

  ${({ theme }) => theme.widget.closeButton};
`;

export const Crest = styled(CrestIcon)`
  fill: #000;
`;

export const Background = styled.div<{ isAnimate: boolean; isTooltipOpen: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: all 300ms ease-in-out;
  animation-name: ${({ isAnimate, theme }) =>
    isAnimate ? theme.animation.widget.side.background.close : theme.animation.widget.side.background.open};
  animation-duration: 300ms;
  animation-timing-function: ease-in-out;
  animation-delay: ${({ isAnimate }) => (isAnimate ? '0s' : '75ms')};
  animation-fill-mode: forwards;

  ${({ isAnimate, isTooltipOpen, theme }) => {
    if (!isAnimate && isTooltipOpen) {
      return css`
        background: linear-gradient(101.58deg, #fff 25.07%, ${theme.colors.light} 143.84%);
        ${theme.widget.background.tooltip};
      `;
    }
    if (!isAnimate && !isTooltipOpen) {
      return css`
        background: linear-gradient(101.95deg, ${theme.colors.light} -12.29%, #fff 68.05%);
        ${theme.widget.background.title};
      `;
    }
    return '';
  }}
`;
